import React, { useContext, useEffect, useState } from "react";
import {
    TextField,
    Button,
    FormControl,
    FormLabel,
} from "@mui/material";
import { toast } from "react-toastify";
import axios from "axios";
import { ContextData } from "../../../../context/Context";
import baseUrl from "../../../../BaseURL";
import { Getrequest, Putrequest } from "../../../../context/AxiosRequest";




function LimitScholarship() {




    const { accesstoken } = useContext(ContextData);
    const [Reload, setReload] = useState(true);
    const [Limit,setLimit]  = useState(null)
    const [count, setCount] = useState(0);

    const handleUpdate = async (count) => {


           const response = await Putrequest(`/auth/limit_scholarship`,{count:count},accesstoken)
              toast.success(response)
             

    };

    

    useEffect(()=>{


        async function FetchData (){
             
            const response = await Getrequest("/auth/get_limit_scholarship",accesstoken)

            setLimit(response.set_limit)
   
         }

         FetchData()

    },[Reload])

   

    const handleIncrease = () => {
        setCount((prevCount) => Math.min(5, prevCount + 1));

       
    };

    const handleDecrease = () => {
        setCount((prevCount) => Math.max(1, prevCount - 1));

        
    }; 

    return (
        <div className="update-con w-full h-full flex justify-center p-6">
              <div className="w-full h-40 bg-slate-50 flex justify-center items-center flex-col">

            <FormControl component="fieldset">
                <FormLabel sx={{paddingTop:"5px"}} component="legend">Set Limit For Scholarship To Apply Per Applicant</FormLabel>
            </FormControl>
            <TextField
                type="number"
                label="Count"
                variant="outlined"
                value={count}
                inputProps={{ readOnly: true }}
            />
            <div className="pt-3"> 
                <Button
                    variant="outlined"
                    color="primary"
                    onClick={handleIncrease}
                    disabled={count === 5}
                >
                    Increase
                </Button>
                <Button
                    variant="outlined"
                    color="secondary"
                    onClick={handleDecrease}
                    disabled={count === 1}
                    sx={{marginLeft:"8px"}}
                > 
                    Decrease
                </Button>

                <Button
                    variant="contained"
                    color="success"
                    onClick={ ()=> handleUpdate(count)}
                    sx={{marginLeft:"8px"}} 
                > 
                    Set
                </Button>
           

              </div>
            </div>
        </div>
    );
}

export default LimitScholarship;
